import { TypeAppliedTheme } from "@src/Stores/Themes/types";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import theme from "@src/Tools/MuiTheme";

const useStyles = makeStyles(theme => ({
  paperRoot: {
    marginTop: "2em",
    opacity: "0.9",
    [theme.breakpoints.up('sm')] :{
      width: "550px",
    }
  },
  loginGrid: {
    height: "100vh",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  loginLogo: {
    maxWidth: "15rem",
    maxHeight: "3rem",
  },
}));

export default useStyles;

export const STGrid = styled(Grid)`
  background-image: url(${(props: { loginbackgroundlandscapeimageurl: string }) =>
    props.loginbackgroundlandscapeimageurl});
  background-color: ${(props: { theme: TypeAppliedTheme }) => (props.theme ? props.theme.secondaryColor : "")};
  ${theme.breakpoints.down("sm")} {
    background-image: url(${(props: { loginbackgroundportraitimageurl: string }) =>
      props.loginbackgroundportraitimageurl});
  }
`;

export const STWrapper = styled(Grid)`
  && {
    min-height: 200px;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 15px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;
